const radiusBase = 4;

const radius = {
    xs: `${radiusBase}px`,
    sm: `${radiusBase + 2}px`,
    md: `${radiusBase + 4}px`,
    lg: `${radiusBase + 8}px`,
    xl: `${radiusBase + 12}px`,
    full: '9999px'
} as const;

export default radius;
